import React, { Component } from 'react';
import * as func from "../../../utils/functions";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH, IMPORT_STATUS_NAME} from "../../../wpconfig";
import ReactPaginate from "react-paginate";

class KciForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInit : false,
      param : {
        'type' : 'kci',
        "org_name": '"부산대학교"|"Pusan National University"',//부산대학교 and Pusan National University
        "resource_title": '',
        "start_day" : '',
        "end_day" : '',
        'current_page': 1,
        'record_per_page': 100,
      },
      records : [],
      totalRecords : 0,
      totalPage : 0,
      format : [
        // {"value": "excel", "name": "Excel"},
        {"value": "api", "name": "API 검색"}
      ],
      action : 'admin/import/',
    }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    let param = this.state.param
    if (location.search.substring(1)) {
      param = func.parseParams(location.search.substring(1))
      delete param.page
      param.type = 'kci'
      param.uploadType = 'api'
    }

    func.getData(this.state.action + 'list', param).then((response) => {
      // console.log(response)
      if (response) {
        this.setState({
          isInit: true,
          records: response.records,
          totalPage: response.pageInfo.totalPage,
          totalRecords: response.pageInfo.totalResult,
          // param: param
        });
      }
    });
  }

  onChange = (event) => {
    let param = this.state.param
    param[event.target.name] = event.target.value
    this.setState({param : param})
    this.forceUpdate()
  };

  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.state.param;
    param['current_page'] = paged;

    func.getData(this.state.action + 'list', param).then((response) => {
      if(response) {
        this.setState({
          param : param,
          records : response.records,
          totalPage : response.pageInfo.totalPage,
          totalRecords : response.pageInfo.totalResult,
        });
        const url = objectToQueryString(param);
        pushUrl('검색', BASE_PATH + 'wp-admin/admin.php?page=researchmind-import&' + url, this.props.param);
      }
    });
  }

  betweenDay(firstDate, secondDate) {
    let firstDateObj = new Date(firstDate.substring(0, 4), firstDate.substring(4, 6) - 1, firstDate.substring(6, 8));
    let secondDateObj = new Date(secondDate.substring(0, 4), secondDate.substring(4, 6) - 1, secondDate.substring(6, 8));
    let betweenTime = Math.abs(secondDateObj.getTime() - firstDateObj.getTime());
    return Math.floor(betweenTime / (1000 * 60 * 60 * 24));
  }

  submit = (e) => {
    //빈파일이 아닌 경우 함수 진행
    //FormData 생성
    const p = this.state.param
    if(!p.org_name)
      this.org_name.focus()
    else if(!p.start_day)
      this.start_day.focus()
    else if(!p.end_day)
      this.end_day.focus()
    else {
      let dateDiff = this.betweenDay(p.start_day, p.end_day)
      if(dateDiff > 31) {
        alert('기한을 한달안으로 선택해주세요.')
      } else {
        func.getData(this.state.action + 'kci_parse', p).then((response) => {
          if (response.code === 'ok') {
            location.reload()
          } else {
            alert('전산팀에 문의해주세요.')
          }
        });
      }
    }
  }

  render() {
    return (
      <>
        <div className="row mt-4 mb-2">
          <div className="col-md-12 form-group">
            <label htmlFor="journal_title"><strong>KCI 논문 반입</strong></label>
            <div className="row">
              <div className="col">
                <div className="card p-0">
                  <div className="card-header">
                    반입 포맷
                  </div>
                  <ul className="list-group list-group-flush">
                    {
                      this.state.format.length > 0 &&
                      this.state.format.map((data, index) => {
                        return (
                          <li key={index} className="list-group-item m-0">
                            <div className="form-check">
                              <input className="form-check-input" type="radio" name="exampleRadios"
                                     id={"radio" + index} value={this.value} onChange={this.onChange} checked/>
                              <label className="form-check-label pl-2" htmlFor={"radio" + index}>
                                {data.name}
                              </label>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 form-group">
            <table className="table table-striped table-thin border-bottom mt-4">
              <colgroup>
                <col width="200px"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <tr>
                  <th>기관명</th>
                  <td>
                    <div className="row">
                      <div className="col-3">
                        <input type="text" className="form-control"
                               value={this.state.param.org_name}
                               name="org_name"
                               onChange={this.onChange}
                               ref={(ref) => this.org_name = ref}/>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>등록일</th>
                  <td>
                    <div className="form-inline">
                      <div className="form-group">
                        <input type="text" className="form-control"
                               value={this.state.param.start_day}
                               name="start_day"
                               onChange={this.onChange}
                               ref={(ref) => this.start_day = ref}/>
                      </div>
                      <div className="form-group ml-2 mr-2">~</div>
                      <div className="form-group">
                        <input type="text" className="form-control"
                               value={this.state.param.end_day}
                               name="end_day"
                               onChange={this.onChange}
                               ref={(ref) => this.end_day = ref}/>
                      </div>
                      <div className="form-group"><span className="ml-3">예. 20210101~20210120</span></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>논문명(선택)</th>
                  <td>
                    <input type="text" className="form-control"
                           value={this.state.param.resource_title}
                           name="resource_title"
                           onChange={this.onChange}
                           ref={(ref) => this.resource_title = ref}/>
                  </td>
                </tr>
                {/*<tr>*/}
                {/*  <th>페이지당 레코드 수</th>*/}
                {/*  <td>*/}
                {/*    <select className="form-control"*/}
                {/*            value={this.state.param.record_per_page}*/}
                {/*            onChange={this.onChange}*/}
                {/*            name="record_per_page"*/}
                {/*            ref={(ref) => this.record_per_page = ref}>*/}
                {/*      <option value="10">10</option>*/}
                {/*      <option value="20">20</option>*/}
                {/*      <option value="50">50</option>*/}
                {/*      <option value="100">100</option>*/}
                {/*    </select>*/}
                {/*  </td>*/}
                {/*</tr>*/}
              </tbody>
            </table>
            <div className="input-group">
              <button className="btn btn-sm btn-primary" type="button" onClick={this.submit}>검색 불러오기</button>
            </div>
            <>
              <table className="table table-striped table-thin border-bottom mt-4">
                <colgroup>
                  <col width="200px"/>
                  <col width="80px"/>
                  <col width=""/>
                  <col width="80px"/>
                  <col width="80px"/>
                  <col width="80px"/>
                  <col width="150px"/>
                  <col width="100px"/>
                </colgroup>
                <thead>
                <tr>
                  <th scope="col">작업 ID</th>
                  <th scope="col">유형</th>
                  <th scope="col">파일명</th>
                  <th scope="col">전체</th>
                  <th scope="col">중복</th>
                  <th scope="col">에러</th>
                  <th scope="col">반입일자</th>
                  <th scope="col">상태</th>
                </tr>
                </thead>
                <tbody>
                {this.state.isInit &&
                this.state.records.length > 0 ? this.state.records.map((record, index) => {
                      return (
                          <tr key={record.unique_id}>
                            <td><a href={"./admin.php?page=researchmind-import&type="+record.resource_type+"&record_id=" + record.unique_id}>{record.unique_id}</a></td>
                            <td>{record.resource_type}</td>
                            <td>{record.file_name}</td>
                            <td>{record.row_count}</td>
                            <td>{record.dup_count}</td>
                            <td>{record.err_count}</td>
                            <td>{record.input_date}</td>
                            <td>{IMPORT_STATUS_NAME[record.progress_status]}</td>
                          </tr>
                      )
                    })
                    :
                    <tr><td colSpan={8}>결과가 없습니다.</td></tr>
                }
                </tbody>
              </table>
              {this.state.totalPage > 0 &&
              <div className="mt-4">
                <div>
                  <div className="paging-wrap">
                    <ReactPaginate
                      forcePage={Number(this.state.param.current_page) - 1}
                      pageCount={this.state.totalPage}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={10}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item page-item-prev'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item page-item-next'}
                      nextLinkClassName={'page-link'}
                    />
                  </div>
                </div>
              </div>
              }
            </>
          </div>
        </div>
      </>
    )
  }
}

export default KciForm;
